$('[data-toggle="collapse"]').collapseExtensions();

//inject the select2 scrolling fix;

$.fn.select2.amd.require(["select2/dropdown/attachBody", "select2/utils"], function (AttachBody, Utils) {
    AttachBody.prototype._attachPositioningHandler = function (decorated, container) {
        var self = this;
        var scrollEvent = "scroll.select2." + container.id;
        var resizeEvent = "resize.select2." + container.id;
        var orientationEvent = "orientationchange.select2." + container.id;
        var $watchers = this.$container.parents().filter(Utils.hasScroll);
        $watchers.each(function () {
            $(this).data("select2-scroll-position", {
                x: $(this).scrollLeft(),
                y: $(this).scrollTop()
            });
        });
        $watchers.on(scrollEvent, function (ev) {
            var position = $(this).data("select2-scroll-position");
            $(this).scrollTop(position.y);
        });
        $(window).on(scrollEvent + " " + resizeEvent + " " + orientationEvent,
            function (e) {
                self._positionDropdown();
                self._resizeDropdown();
            }
        );
    };
});


$(function () {
    //HACK: bootstrap 2 used to do this magically. so we have to handle it.
    $('[data-toggle="modal"]').each(function () {
        var trigger = $(this);
        var modal = $(trigger.attr('data-target'));
        if (!modal) {
            modal = ($('body').append($('<div class="modal" tabindex="-1" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-body"></div></div></div></div>'))).find('modal-body');
        }
        modal.on('show.bs.modal', function () {
            var modalHref = trigger.attr('href');
            if (modalHref && modalHref !== '#' && modalHref !== 'javascript;' && modalHref !== 'javascript:void(0);' && modalHref !== 'javascript:void(0)' && modalHref !== 'javascript:;') {
                var modalBody = modal.find('.modal-body');
                $.get(modalHref)
                    .done(function (data) {
                        modalBody.html(data);
                    })
                    .fail(function (data) {
                        modalBody.html('<span class="text-danger">Service error.</span>');
                        console.error(data);
                    });
            }
        });
    });

    //auto-dismiss alerts
    var dismissThreshold = 800;
    $(".alert-slide-container.auto-dismiss").each(function (i, elem) {
        var t = 0;
        var container = $(elem);
        var progressBar = container.find(".progress-bar");
        var loop = function () {
            window.setTimeout(function () {
                t++;
                if (t > dismissThreshold) {
                    container.dismissSlideAlert();
                } else {
                    var pc = 100 * (t / dismissThreshold);
                    progressBar.css("width", pc + "%").attr("aria-valuenow", pc);
                    loop();
                }
            }, 5);
        };
        loop();
    });


    //HACK: BS4 doesn't support nested dropdowns, which did work in BS2
    $(document).on('click', '.dropdown-menu .dropdown-toggle', function (e) {
        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        var $subMenu = $(this).next(".dropdown-menu");
        $subMenu.toggleClass('show');


        $(this).parents('.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
            $('.dropdown-submenu .show').removeClass("show");
        });

        return false;
    });

    $('.form-group:empty').hide();

    $('[data-move-to-body]').appendTo('body');
    $('[data-toggle="drawer"]').drawer();
    $('[data-toggle="dropdown"]').dropdown();
    $('[data-toggle="popover"]').popover();
    $('[data-toggle="dropdown"]').dropdown();
    $('[data-toggle="tooltip"]').tooltip();


    $('#body').scroll(function () {
        $('.datePicker, .hasDatepicker').blur().datepicker('hide');
    });

    if ($(".actions-container").height() === 0) {
        //$('#actions-panel').hide();
    }
});


(function () {
    //things that shouldn't really wait for the document to be ready.
    $(document).globalRippleButtons();
    registerAll('[data-toggle="tooltip"]', function (elem) { elem.colouredTooltips(); });
    registerAll('[data-toggle="collapse"]', function (elem) { elem.collapseExtensions(); });

    registerAll('.twitter-typeahead', function (elem) {
        var parent = elem.parent();
        elem.width(parent.width());
    });

    registerAll('select', function (elem) {
        function hasAttr(key) {
            return elem.attr(key) !== undefined;
        }

        if (hasAttr('data-filter') || hasAttr('data-disable-select2') || hasAttr('ng-model') || elem.hasClass('select2-hidden-accessible')) {
            return;
        }

        var placeholder = elem.attr('placeholder');
        var placeholderId = elem.attr('placeholder-id');
        var data = undefined;
        if (placeholder !== undefined) {
            if (elem.attr('multiple')) {
                data = {
                    placeholder: placeholder
                };
            } else {
                if (placeholderId !== undefined) {
                    data = {
                        placeholder: placeholder,
                        id: placeholderId
                    };
                } else {
                    data = {
                        placeholder: placeholder,
                        allowClear: true
                    };
                }
            }
        }
        elem.removeClass('form-control').select2(data);
    });

    $(document).on('select2:close', function (e) {
        var evt = "scroll.select2";
        $(e.target).parents().off(evt);
        $(window).off(evt);
    });

    registerAll('.nav-scroll', function (elem) {
        elem.each(function () {
            var scrollNav = $(this);
            var active = scrollNav.find('.active');
            scrollNav.scrollToNavElement(active, 0);
            scrollNav.find('.nav-link').on('click', function (event) {
                scrollNav.scrollToNavElement($(event.currentTarget), 100);
            });
            scrollNav.scrollToNavElement(active, 0);
            scrollNav.addScrollArrows();
            count = 0;
            var interval = window.setInterval(function () {
                scrollNav.scrollToNavElement(active, 0);
                count++;
                if (count >= 500) {
                    window.clearInterval(interval);
                }
            }, 1);
        });
    });

    registerAll('input:required, textarea:required, select:required', function (elem) {
        elem.parent().find('label').addClass('required');
    })

    function registerAll(selector, action) {
        $('html').arrive(selector, function () {
            var elem = $(this);
            //not in DOM
            if (!jQuery.contains(document.documentElement, elem[0])) {
                return;
            }
            action(elem);
        });
    }

})();
